import React, { FC, SetStateAction, useEffect, useState } from "react";
import { SectionHeading } from "../SectionHeading/SectionHeading";
import Carousel from "../Carousel/Carousel";
import { SocialCard } from "../SocialCard/SocialCard";
import axios from "axios";

enum SocialMediaSource {
  INSTAGRAM = "instagram",
  LINKEDIN = "linkedin",
}

const tabOptions: { label: string; value: SocialMediaSource }[] = [
  {
    label: "Instagram",
    value: SocialMediaSource.INSTAGRAM,
  },
  {
    label: "Linkedin",
    value: SocialMediaSource.LINKEDIN,
  },
];

type MappedJuicerPost = { imageUrl: string; postUrl: string; text: string };

const getJuicerFeed = async (
  params: any,
  feedId: string,
  setData: React.Dispatch<SetStateAction<MappedJuicerPost[]>>
) => {
  try {
    const response = await axios.get(
      `https://www.juicer.io/api/feeds/${feedId}`,
      {
        params: {
          per: params.pageSize,
          page: 1,
        },
      }
    );

    const mappedItems: MappedJuicerPost[] = response.data.posts.items.map(
      (item) => ({
        imageUrl: item.image,
        postUrl: item.full_url,
        text: item.unformatted_message,
      })
    );

    setData(mappedItems);
  } catch {
    console.error("Error fetching Juicer data");
    setData([]);
  }
};

type SocialMediaProps = {
  feedId: string;
  pagination: {
    pageSize: number;
  };
};

const getJuicerFeedBySocialMediaSource: { [key in SocialMediaSource]: string } =
  {
    [SocialMediaSource.INSTAGRAM]: "wsmsocialwall",
    [SocialMediaSource.LINKEDIN]: "wilhelmsengroup",
  };

const SocialMedia: FC<SocialMediaProps> = (props) => {
  const [source, setSource] = useState<SocialMediaSource>(
    SocialMediaSource.LINKEDIN
  );
  const [items, setItems] = useState<MappedJuicerPost[]>([]);

  useEffect(() => {
    getJuicerFeed(
      props.pagination,
      getJuicerFeedBySocialMediaSource[source],
      setItems
    );
  }, [source]);

  return (
    <section className="z-40 container pb-28">
      <div className="flex justify-between">
        <SectionHeading
          colorVariant="primary"
          title="Wilhelmsen Linkedin feed"
        />

        {/* TODO uncomment when toggle available*/}
        {/*<div>*/}
        {/*  <Tabs<SocialMediaSource> tabs={tabOptions} setSource={setSource} />*/}
        {/*</div>*/}
      </div>

      {!!items.length && (
        <Carousel>
          {items.map((post, index) => (
            <SocialCard
              postUrl={post.postUrl}
              imageUrl={post.imageUrl}
              text={post.text}
              key={index}
            />
          ))}
        </Carousel>
      )}
    </section>
  );
};

export default SocialMedia;
